import React from 'react';
import {
  getInvoicePaymentProgress,
  type ServiceFeeDebtInvoice,
} from '../../utils/serviceFeeDebt';

function formatListAmount(value: number): string {
  return new Intl.NumberFormat('vi-VN', { maximumFractionDigits: 0 }).format(Math.round(value));
}

type Props = {
  invoice: ServiceFeeDebtInvoice & { closingDebt?: number | null };
  displayAmount: number;
  children?: React.ReactNode;
};

export const ServiceFeeInvoiceAmountCell: React.FC<Props> = ({
  invoice,
  displayAmount,
  children,
}) => {
  const progress = getInvoicePaymentProgress(invoice);

  return (
    <>
      <div className="flex items-center gap-2 font-medium">
        {formatListAmount(displayAmount)}
        {children}
      </div>
      {progress && (
        <div className="text-xs text-gray-600 mt-1 font-normal">
          Đã thu: {formatListAmount(progress.paidAmount)}
          <span className="mx-1">·</span>
          <span className={progress.remainingDebt > 0 ? 'text-red-600' : 'text-green-700'}>
            Còn nợ: {formatListAmount(progress.remainingDebt)}
          </span>
        </div>
      )}
    </>
  );
};
